import { Injectable } from '@angular/core';
import { camelCase } from 'change-case';
import { snakeCase } from 'lodash';
import { TableCalculationsUtils } from '../utils/table-calculations.utils';

@Injectable({
  providedIn: 'root'
})
export class CompanyRankingMapperService {

  constructor(
    private readonly tableCalculationsUtils: TableCalculationsUtils
  ) { }

  public mapToDataTable(criteriaGroup: any, criteriasData: any): any {
    return criteriasData.map((companyMaintenanceData) => {
      const criterias = this.mapCriterias(criteriaGroup, companyMaintenanceData);
      const totalPoints = this.tableCalculationsUtils.getTotalPoints(criterias);
      const totalDiscount = this.tableCalculationsUtils.getTotalDiscount(criterias);

      return {
        id: companyMaintenanceData.company.id,
        name: companyMaintenanceData.company.name,
        avatarUrl: companyMaintenanceData.company.avatarUrl,
        totalPoints: totalPoints,
        totalDiscount: totalDiscount,
        criterias: criterias
      };
    });
  }

  private mapCriterias(criteriaGroup: any, criteriasData: any): any {
    const result = this.setCriteriaDefaultValues(criteriaGroup.criterias);

    const { company, __typename, ...criteriaDataByCompany } = criteriasData;
    const criteriaArray = criteriaGroup.criterias;

    for (const criteria of criteriasData.criteriasResult) {
      const matchingCriteria = criteriaArray.find((c) => c.id === criteria.id);

      result[matchingCriteria.id] = {
        value: criteria.value,
        ruleName: this.transformRuleName(matchingCriteria.ruleName),
        points: this.tableCalculationsUtils.calculatePointsForCriteria(this.transformRuleName(matchingCriteria.ruleName), criteria.value, matchingCriteria),
        discount: this.tableCalculationsUtils.calculateDiscountForCriteria(this.transformRuleName(matchingCriteria.ruleName), criteria.value, matchingCriteria)
      };
    }

    return result;
  }

  public transformRuleName (ruleName): any {
    return {
      accepted_percentage: 'acceptedPercentage',
      refused_percentage: 'refusedPercentage',
      completed_percentage: 'completedPercentage',
      incompleted_percentage: 'incompletedPercentage',
      average_rating: 'averageRating',
      response_on_time_percentage: 'responseOnTimePercentage',
      solution_on_time_percentage: 'solutionOnTimePercentage',
      requested_interval: 'requestedInterval',
      on_negotiation_interval: 'onNegotiationInterval',
      pending_interval: 'pendingInterval',
      scheduled_interval: 'scheduledInterval',
      in_progress_interval: 'inProgressInterval',
      reported_interval: 'reportedInterval',
      response_interval: 'responseInterval',
      solution_interval: 'solutionInterval',
      average_response_time_in_days: 'averageResponseTimeInDays',
      average_close_time_in_days: 'averageCloseTimeInDays',
      response_on_time_percentage_by_range: 'responseOnTimePercentageByRange',
      solution_on_time_percentage_by_range: 'solutionOnTimePercentageByRange'
    }[ruleName] || ruleName;
  }

  private setCriteriaDefaultValues(criteriaArray: any): any {
    const result = {};

    for (const criteria of criteriaArray) {
      result[criteria.id] = {
        value: 0,
        points: 0
      };
    }

    return result;
  }
}
